import InsuranceManual from './InsuranceManual'

export default InsuranceManual
